/*
  PDP JIGHEAD KUTUSU (22 Eki 2026) — snippets/pdp-jighead.liquid.
  Kutu KAPIDA ÖDEMEYE ÖZEL: "Sepete Ekle" akışına girmez; kapıda ödeme formundaki
  fırsat kartıyla (yigitfy-cod-form §4b, [data-ycod-firsat-grup-vids]) senkron çalışır.

  - Gram çipi seçmek niyet sayılır → kutu işaretlenir (formdaki çiplerle aynı kural).
  - Kutu işaretliyken popup bu ürünü sormaz (data-ycod-pop-for geçici olarak boşaltılır).
  - Form açılınca: kutu işaretliyse kartta aynı gram seçilir ve kart işaretlenir; ardından
    formdaki durum kutuya geri okunur (popup'ta "Ekle" denmişse kutu da işaretlenir).
  - Form ilk kez açıldıktan sonra kutudaki her değişiklik karta anında aktarılır; formdaki
    değişiklik kutuya yansır.
  Kart yigitfy-cod.js'te bağlı olduğundan değişiklik hep 'change' olayıyla yapılır: çip için
  firsatSecenekUygula + kutu işareti + toplam orada hesaplanır; burada fiyat HESAPLANMAZ.
*/
(function () {
  'use strict';

  var kutu = document.querySelector('[data-pdp-jig]');
  if (!kutu) return;
  var onay = kutu.querySelector('[data-pdp-jig-onay]');
  var radyolar = Array.prototype.slice.call(kutu.querySelectorAll('[data-pdp-jig-gram]'));
  if (!onay || !radyolar.length) return;

  var adEl = kutu.querySelector('[data-pdp-jig-ad]');
  var fiyatEl = kutu.querySelector('[data-pdp-jig-fiyat]');
  var katalogEl = kutu.querySelector('[data-pdp-jig-katalog]');
  var yuzdeEl = kutu.querySelector('[data-pdp-jig-yuzde]');
  var ipucuEl = kutu.querySelector('[data-pdp-jig-ipucu]');
  var img = kutu.querySelector('.pdp-jig__img');
  var modalAcildi = false;
  var yaziyor = false;

  function para(kurus) {
    var T = window.ArkhelaisTheme || {};
    if (T.formatMoney) return T.formatMoney(kurus);
    return (kurus / 100).toFixed(2).replace('.', ',') + ' TL';
  }

  function secili() {
    return radyolar.filter(function (r) { return r.checked; })[0] || radyolar[0];
  }

  function olay(ad) {
    try { if (window.clarity) window.clarity('event', ad); } catch (e) {}
  }

  function popAyarla() {
    var pop = document.querySelector('[data-ycod-pop]');
    if (!pop) return;
    if (!pop.hasAttribute('data-pop-asil')) pop.setAttribute('data-pop-asil', pop.getAttribute('data-ycod-pop-for') || '');
    pop.setAttribute('data-ycod-pop-for', onay.checked ? '0' : pop.getAttribute('data-pop-asil'));
  }

  function goster() {
    var r = secili();
    if (adEl && r.getAttribute('data-ad')) adEl.textContent = r.getAttribute('data-ad');
    var f = parseInt(r.getAttribute('data-fiyat'), 10) || 0;
    var k = parseInt(r.getAttribute('data-katalog'), 10) || 0;
    if (fiyatEl && f) fiyatEl.textContent = para(f);
    if (katalogEl && k) katalogEl.textContent = para(k);
    if (yuzdeEl && f && k > f) yuzdeEl.textContent = '%' + Math.round(((k - f) * 100) / k) + ' İNDİRİM';
    if (ipucuEl) ipucuEl.textContent = r.getAttribute('data-ipucu') || '';
    var src = r.getAttribute('data-gorsel');
    if (img && src && img.getAttribute('src') !== src) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    }
    kutu.classList.toggle('is-secili', onay.checked);
    popAyarla();
  }

  /** Kapıda ödeme formundaki jighead kartı (gruptaki varyantlardan biri bizim çiplerimizde). */
  function kart() {
    var vidler = radyolar.map(function (r) { return r.value; });
    var kartlar = document.querySelectorAll('[data-ycod-firsat-grup-vids]');
    for (var i = 0; i < kartlar.length; i++) {
      var g = String(kartlar[i].getAttribute('data-ycod-firsat-grup-vids') || '').split(',');
      if (g.some(function (v) { return v && vidler.indexOf(v) > -1; })) return kartlar[i];
    }
    return null;
  }

  function degistir(el, deger) {
    el.checked = deger;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function karta() {
    var k = kart();
    if (!k || k.hidden) return;
    var box = k.querySelector('[data-ycod-firsat]');
    if (!box) return;
    yaziyor = true;
    try {
      if (onay.checked) {
        var r = secili();
        var mr = k.querySelector('[data-ycod-firsat-secenek][value="' + r.value + '"]');
        if (mr && !mr.checked) degistir(mr, true); // kart varyantı/fiyatı + kutu işareti orada
        if (!box.checked) degistir(box, true);
      } else if (box.checked) {
        degistir(box, false);
      }
    } finally {
      yaziyor = false;
    }
  }

  function karttan() {
    var k = kart();
    if (!k || k.hidden) return;
    var box = k.querySelector('[data-ycod-firsat]');
    var mr = k.querySelector('[data-ycod-firsat-secenek]:checked');
    if (!box) return;
    onay.checked = box.checked;
    if (mr) radyolar.forEach(function (r) { r.checked = r.value === mr.value; });
    goster();
  }

  onay.addEventListener('change', function () {
    goster();
    olay(onay.checked ? 'pdp_jighead_eklendi' : 'pdp_jighead_kaldirildi');
    if (modalAcildi) karta();
  });

  radyolar.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!r.checked) return;
      onay.checked = true;
      goster();
      olay('pdp_jighead_gram');
      if (modalAcildi) karta();
    });
  });

  // Form açılışını izle: yigitfy-cod.js openModal → root.hidden = false
  var root = document.querySelector('[data-ycod]');
  if (root && window.MutationObserver) {
    var acik = !root.hidden;
    new MutationObserver(function () {
      var simdi = !root.hidden;
      if (simdi && !acik) {
        modalAcildi = true;
        // yalnız kutu işaretliyse aktar: işaretsizken popup'ta "Ekle" denmiş olabilir, kart silinmesin
        if (onay.checked) karta();
        // sepet modunda kart, sepet okununca gizlenebilir; durum bir an sonra geri okunur
        setTimeout(karttan, 0);
        var k = kart();
        if (k && !k.dataset.pdpJigBagli) {
          k.dataset.pdpJigBagli = '1';
          k.addEventListener('change', function () {
            if (yaziyor) return;
            setTimeout(karttan, 0);
          });
        }
      }
      acik = simdi;
    }).observe(root, { attributes: true, attributeFilter: ['hidden'] });
  }

  goster();
})();
